import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import { usePageSeo } from '@/hooks/usePageSeo';
import Hero from './components/Hero';
import FeaturedWorks from './components/FeaturedWorks';
import LatestNews from './components/LatestNews';
import CategoryEntry from './components/CategoryEntry';

export default function Home() {
  usePageSeo({
    title: '小仓优子个人介绍与最新动态_演员资料库',
    description:
      '小仓优子官方网站，提供全面的演员资料、最新影视作品动态和相关资讯，助你深入了解小仓优子的一切信息。',
    keywords: '小仓优子,演员介绍,影视作品,明星动态,艺人资料,最新消息',
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <FeaturedWorks />
        <LatestNews />
        <CategoryEntry />
      </main>
      <SiteFooter />
    </div>
  );
}